export const getIntNumberByString = (num: string | undefined) =>
  num && !Number.isNaN(Number(num)) ? Number(num) : null;
